import VueI18n from 'vue-i18n'
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import Axios from 'axios'
import iView from 'iview'

import router from './router'
import fastclick from 'fastclick'
import 'common/stylus/index.styl'
import 'iview/dist/styles/iview.css'

Vue.use(VueI18n)

const DEFAULT_LANG = 'zh'
const LOCALE_KEY = 'localeLanguage'
const locales = {
  zh: require('../static/content/zh.json'),
  en: require('../static/content/en.json'),
}
const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
})

export const setup = lang => {
  if (lang === undefined) {
    lang = window.localStorage.getItem(LOCALE_KEY)
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG
    }
  }
  window.localStorage.setItem(LOCALE_KEY, lang)

  Object.keys(locales).forEach(lang => {
    document.body.classList.remove(`lang-${lang}`)
  })
  document.body.classList.add(`lang-${lang}`)
  document.body.setAttribute('lang', lang)
//把当前语言设置到vue的配置里面，方便在代码中读取
  Vue.config.lang = lang
  i18n.locale = lang
}
//设置默认语言为中文
setup('zh')
//把i18n绑定到window上，方便我们在vue以外的文件使用语言包
window.i18n = i18n;
export default i18n

Vue.config.productionTip = false

Vue.prototype.$axios = Axios

fastclick.attach(document.body)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js